import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowBack = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 14,
	viewBox: "0 0 8 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_8_204)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M8 12L3 7L8 2L7 0L9.53674e-07 7L7 14L8 12Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_8_204",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 8,
				height: 14,
				fill: "white",
				transform: "matrix(-1 0 0 1 8 0)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgArrowBack);
export { ForwardRef as ReactComponent };
